/**
 * Service pour les psychologues
 */
export class PsychologistService {

	/**
	 * Récupère les coordonées d'un psychologue à partir de son id et de ses coordonées concaténés
	 *
	 * @param psychologistIdByAddress L'id du psychologue et ses coordonées concaténés
	 * @returns Les coordonées du psychologue
	 */
	static getCoordinatesFromPsychologistIdByAddress(psychologistIdByAddress: string): string {
		const EXPECTED_PARTS_COUNT = 2;

		return psychologistIdByAddress.split(';').length === EXPECTED_PARTS_COUNT
			? psychologistIdByAddress
			: psychologistIdByAddress.split(';').slice(1).join(';');
	}
}
